/**
 * Utilities for managing scroll position and preventing background scroll
 * when modals/drawers are open on mobile devices
 */

let scrollLockCount = 0;

/**
 * Locks body scroll without changing scroll position
 */
export function lockScroll(): void {
  scrollLockCount++;

  // Only apply lock on first call
  if (scrollLockCount === 1) {
    const body = document.body;

    // Store original overflow style so we can restore it
    body.dataset.originalOverflow = body.style.overflow || "";

    // Apply scroll lock - simply prevent scrolling without changing position
    body.style.overflow = "hidden";
  }
}

/**
 * Unlocks body scroll and restores original overflow style
 */
export function unlockScroll(): void {
  if (scrollLockCount > 0) {
    scrollLockCount--;
  }

  // Only restore on last unlock call
  if (scrollLockCount === 0) {
    const body = document.body;

    // Restore original overflow style
    body.style.overflow = body.dataset.originalOverflow || "";

    // Clean up data attribute
    delete body.dataset.originalOverflow;
  }
}

/**
 * Force unlock all scroll locks (useful for cleanup)
 */
export function forceUnlockScroll(): void {
  scrollLockCount = 0;
  const body = document.body;

  // Restore original overflow style
  body.style.overflow = body.dataset.originalOverflow || "";

  // Clean up data attribute
  delete body.dataset.originalOverflow;
}
